



















































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import Spot from "@/models/Spot";
import VModalVideo from "../VModalVideo.vue";
import VVideoButton from "@/components/VVideoButton.vue";

import VAudio from "@/components/VAudio.vue";

@Component({
  components: {
    VAudio,
    VModalVideo,
    VVideoButton,
  },
})
export default class StickyPlayer extends Vue {
  @Prop({ default: () => [] }) readonly spots!: Spot[];
  @Ref() readonly videoModal!: VModalVideo;

  selected = this.spots[0] || null;

  private currentVideoSources: string[] | null = null;

  get index() {
    return this.spots.map((o) => o.id).indexOf(this.selected.id);
  }

  playVideo(url: string) {
    this.currentVideoSources = [url];
    this.videoModal.show();
    (document.activeElement as HTMLButtonElement)?.blur();
  }

  @Watch("spots")
  onSpotsChanged() {
    this.selected = this.spots[0];
  }

  onHideModal() {
    this.currentVideoSources = null;
  }

  next() {
    const index = this.index < this.spots.length - 1 ? this.index + 1 : 0;
    this.selected = this.spots[index];
  }

  back() {
    const index = this.index > 0 ? this.index - 1 : this.spots.length - 1;
    this.selected = this.spots[index];
  }
}
